// src/components/branch/Navbar.js or similar path

import React, { useContext } from 'react';
import '../../assets/styles/Navbar.css';
import logo from '../../assets/images/MagunexLogo.jpeg';
import { CompanyContext } from '../../context/CompanyContext';

const Navbar = () => {
   const {companyInfo} =useContext(CompanyContext);
  return (
    <div className="navbar-wrapper">
      <div className="navbar-content bg-secondary text-light">
        {/* Left: Logo */}
        <div className="logo">
          <img src={logo} alt="Logo" className="logo-image" />
          <span className="logo-text text-light">{companyInfo.company}</span>
        </div>

        {/* Center: Branch Info */}
        <div className="nav-link">
          <h1 style={{ margin: 0, fontSize: '18px' }}>Trial Polyclinic - Wakrah Branch</h1>
          <p style={{ margin: 0, fontSize: '14px' }}>Email: ... | Tel: ... | WhatsApp: ...</p>
        </div>

        {/* Right: User Info */}
        <div className="btn btn-primary  text-light">
          <span style={{ fontWeight: 'bold' }}>TestUser 123</span>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
